<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .home{
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
    background-color: #f5f5f5;
  }

  .home .banner{
    /*height: 1115px;*/
    /*background:url('../assets/img/topBaner.png')no-repeat;*/
    width: 100%;
    overflow: hidden;
    /*background-size: 100% 100%*/
  }
  .home .navbox{
    background-color: #c42428;
  }
  .home .banner .nav{
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .home .banner .nav img{
    float: left;
    margin-right:90px;
    margin-top: 35px;
  }
  .home .banner .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .home .banner .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 140px;
    text-align: center;
    line-height: 120px;
    color: #ebbfbf;
    font-size: 20px;
    font-weight: 900;
    cursor: pointer;
  }
  .home .banner .nav ul li:hover{
    background-color: #b62125;
    color: #fffefe;
    background-position: 0 21px;
  }
  .home .banner .nav ul li.on{
    background-color: #b62125;
    color: #fffefe;
    background-position: 0 21px;
  }
  .home .banner .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .home .title{
    text-align: center;
    margin: 0 auto;
    margin-top: 100px;
  }

  .home .content{
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    /*margin-bottom: 170px;*/
    padding-bottom: 55px;
    overflow: hidden;
  }
  .home .content .match{
    margin-top: 25px;
    margin-bottom: 40px;
    overflow: hidden;
    width: 1200px;
  }
  .home .content .match ul{
    /*display: flex;*/
    /*display: -webkit-flex;*/
    /*justify-content: space-between;*/
    /*flex-wrap: wrap ;*/
    overflow: hidden;
    min-height:340px;
  }

  .home .content .match ul li{
    width: 288px;
    height: 320px;
    background-color: #fff;
    display: inline-block;
    cursor: pointer;
    margin-bottom: 20px;
    float: left;
    margin-right: 10px;
  }
  .home .content .match ul li .photo{
    width: 288px;
    height: 160px;
    display: inline-block;
    margin-bottom: 15px;
  }
  .home .content .match ul li p{
    margin-left: 15px;
  }
  .home .content .match ul li .gameName{
    margin-bottom: 10px;
    font-size: 22px;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .home .content .match ul li .gameTime{
    margin-bottom: 10px;
    color: #666666;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .home .content .match ul li p img{
    width: 20px;
  }
  .home .content .match ul li .coord{
    bottom: 15px;
    width: 100%;
    margin-top: 20px;
  }
  .home .content .match ul li .coordIcon{
    float: left;
    width: 16px;
    height: 21px;
  }
  .home .content .match ul li .coordName {
    color: #3970d7;
    font-size: 16px;
    margin-left: 10px;
  }
  .home .content .match ul li .gameCode1{
    float: left;
    margin-right: 30px;
    width: 100px;
    height: 35px;
    background-color: #cd262a;
    color: #ffffff;
    border-radius: 3px;
    font-size: 12px;
    text-align: center;
    line-height: 35px;
  }
  .home .content .match ul li .gameCode2{
    float: left;
    margin-right: 30px;
    width: 100px;
    height: 35px;
    background-color: #32b16c;
    color: #ffffff;
    border-radius: 3px;
    font-size: 12px;
    text-align: center;
    line-height: 35px;
  }
  .home .content .match ul li .gameCode3{
    float: left;
    margin-right: 30px;
    width: 100px;
    height: 35px;
    background-color: #727b87;
    color: #ffffff;
    border-radius: 3px;
    font-size: 12px;
    text-align: center;
    line-height: 35px;
  }
  .home .content .match .gameLogin{
    width: 1200px;
    height: 40px;
    margin: 0 auto;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    color: #3366cc;
  }
  .home .content .details{
    overflow: hidden;
  }

  .home .content .newList li{
    padding: 30px;
    overflow: hidden;
    background-color: #ffffff;
    margin-bottom: 15px;
  }
  .home .content .newList li img{
    float: left;
    width: 500px;
    height: 277px;
    cursor: pointer;
  }
  .home .content .newList li .text{
    float: right;
    width: 580px;
  }
  .home .content .newList li .text .title1{
    font-size: 24px;
    color: #333333;
    font-weight: 900;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 65px;
    cursor: pointer;
  }
  .home .content .newList li .text .title2{
    margin-top: 35px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    font-size: 14px;
    color: #949494;
    height: 150px;
  }
  .home .content .newList li .text .gameIcon{
    color: #333333;
    font-size: 14px;
  }
  .home .content .newList li .text .gameIcon img{
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .home .content .newList li .text .gameIcon span{
    float: right;
    font-size: 14px;
    color: #777777;
  }


  /*===========================================================*/
  /*.home .content .details .left{*/
    /*width: 750px;*/
    /*float: left;*/
  /*}*/
  /*.home .content .details .left ul li{*/
    /*padding:20px;*/
    /*background-color: #fff;*/
    /*margin-bottom: 20px;*/
  /*}*/
  /*.home .content .details .left ul li .pic{*/
    /*width: 100%;*/
    /*height: 400px;*/
  /*}*/
  /*.home .content .details .left ul li .icon {*/
    /*width: 20px;*/
  /*}*/
  /*.home .content .details .left ul li .title1 {*/
    /*margin-top: 30px;*/
    /*font-size: 24px;*/
    /*color: #333333;*/
    /*overflow: hidden;*/
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
  /*}*/
  /*.home .content .details .left ul li .title2 {*/
    /*margin-top: 20px;*/
    /*font-size: 14px;*/
    /*color: #666666;*/
    /*text-indent: 1em;*/
    /*display: -webkit-box; /!*作为弹性伸缩盒子模型显示*!/*/
    /*-webkit-line-clamp: 2; /!*显示的行数；如果要设置2行加...则设置为2*!/*/
    /*overflow: hidden;*/
    /*text-overflow: ellipsis; /!* 溢出用省略号*!/*/
    /*/!*! autoprefixer: off *!/*/
    /*-webkit-box-orient: vertical;/!*伸缩盒子的子元素排列：从上到下*!/*/
  /*}*/
  /*.home .content .details .left ul li .gameIcon{*/
    /*margin-top: 30px;*/
    /*padding-top: 32px;*/
    /*border-top: 1px solid #f4f4f4;*/
    /*font-size: 14px;*/
    /*color: #3366cc;*/
  /*}*/
  /*.home .content .details .left ul li .gameIcon img{*/
    /*width: 20px;*/
    /*margin-right: 10px;*/
    /*float: left;*/
  /*}*/
  /*.home .content .details .left ul li .gameIcon .timer{*/
    /*float: right;*/
    /*color: #666666;*/
  /*}*/
  /*.home .content .details .right{*/
    /*float: right;*/
    /*width: 423px;*/
  /*}*/
  /*.home .content .details .right div{*/
    /*margin-bottom: 40px;*/
  /*}*/
  /*.home .content .details .right .logo{*/
    /*margin: 0 auto;*/
    /*display: inline-block;*/
    /*width: 100%;*/
    /*text-align: center;*/
    /*line-height: 30px;*/
    /*font-size: 20px;*/
    /*margin-bottom: 15px;*/
    /*font-weight: 900;*/
  /*}*/
  /*.home .content .details .right .logo img{*/
    /*margin: 0 auto;*/
    /*text-align: center;*/
    /*display: -webkit-box;*/
  /*}*/
  /*.home .content .details .right ul{*/
    /*padding: 30px 20px;*/
    /*background-color: #fff;*/
  /*}*/
  /*.home .content .details .right ul li{*/
    /*background-color: #fff;*/
    /*font-size: 16px;*/
    /*font-weight: 900;*/
    /*color: #333333;*/
    /*height: 55px;*/
    /*line-height: 55px;*/
    /*text-indent: 2em;*/
  /*}*/
  /*.home .content .details .right ul li:nth-child(2n){*/
    /*background-color: #f6f6f6;*/
  /*}*/
  /*.home .content .details .right ul li span{*/
    /*float: right;*/
    /*color: #333333;*/
    /*font-weight: 100;*/
    /*margin-right: 20px;*/
  /*}*/
    /*.home .content .details .right .uls{*/
      /*width: 100%;*/
      /*height: 300px;*/
      /*background:url(../assets/img/NData.jpg);*/
  /*}*/
</style>
<template>
  <div class="home">
    <myhead></myhead>
    <div class="banner">
      <div class="navbox">
        <nav class="nav">
          <img src="../assets/img/logo.png" alt=""/>
          <ul>
            <li class="on" @click="urlFun('/home')">首页</li>
            <li @click="urlFun('/news')">新闻</li>
            <li @click="urlFun('/rules')">规则</li>
            <li @click="urlFun('/videoList')">视频</li>
            <li @click="urlFun('/live')">直播</li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="content">
      <div class="match">
        <ul v-if="gameList">
          <li v-for="(key,index) in gameList" @click="gameFun(key.jumpAddress)">
            <img class="photo" :src="'http://admin.matchon.net'+key.matchPic" alt=""/>
            <!--<img class="photo" src="../assets/img/gameList.png" alt=""/>-->
            <p style="overflow: hidden;margin-top: 10px;margin-bottom: 15px">
              <span style="float: left;color: #cd262a;">{{key.gameName}}</span>
            </p>
            <p class="gameName">{{key.matchName}}</p>
            <p class="coord">
              <span class="gameCode1" v-if="key.status==3">即将开始</span>
              <span class="gameCode2" v-if="key.status==4">进行中</span>
              <span class="gameCode3" v-if="key.status==5">已结束</span>
            </p>
            <p style="float: right;line-height: 35px;margin-right: 15px;font-size: 20px;">￥{{key.rewardNum}}</p>
          </li>
        </ul>
        <div style="text-align: center;cursor: pointer" @click="loginData()">加载更多</div>
      </div>
      <div class="details">
        <ul class="newList">
          <li v-for="(key,index) in newsList" @click="newFun(key.news_id)">
            <img :src="'http://admin.matchon.net//'+key.newsPic" alt=""/>
            <div class="text">
              <p class="title1">{{key.newsTitle}}</p>
              <p class="title2">{{key.introduction}}</p>
              <p class="gameIcon"><img :src="'http://admin.matchon.net/'+key.gameIcon" alt=""/>{{key.gameName}} <span>{{key.createTime}}</span></p>
            </div>
          </li>
        </ul>
        <!--<div class="left">-->
          <!--<ul>-->
            <!--<li v-for="(key,index) in newsList" @click="newFun(key.news_id)">-->
              <!--<img class="pic" :src="'http://admin.matchon.net'+key.newsPic" alt=""/>-->
              <!--<p class="title1">{{key.newsTitle}}</p>-->
              <!--<p class="title2">{{key.introduction}}</p>-->
              <!--<p class="gameIcon"><img v-if="key.gameIcon" class="newsCodeImg" :src="'http://admin.matchon.net'+key.gameIcon" alt=""/>{{key.gameName}} <span class="timer">{{key.createTime}}</span></p>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
        <!--<div class="right">-->
          <!--<div v-for="(key,index) in list">-->
            <!--<p class="logo">-->
              <!--<img :src="'http://admin.matchon.net'+key.logo" alt=""/>-->
              <!--{{key.gameName}}-->
            <!--</p>-->
            <!--<ul v-if="key.list">-->
              <!--<li v-for="(k,i) in key.list">{{i+1}}. {{k.gamerName}} <span>￥{{k.rewardNum}}</span></li>-->
            <!--</ul>-->
            <!--<ul v-else class="uls">-->

            <!--</ul>-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
  import myimg from'../assets/img/NData.jpg'
  import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    name: 'home',
    components: {
      swiper,
      swiperSlide,
      myhead,
      mybottom
    },
    data () {
      return {
        imgs:myimg,
        list:"",
        gameList:"",
        gameAllPage:"",
        gamePage:1,
        newsList:"",
      }
    },

    computed:{

    },
    mounted(){
      this.listData()
      this.gamehData(8,"","","")
      this.newsData()
    },
    methods:{
      gamehData(mpage,code,name,gameId){
        let _this=this;
        let formd=new FormData()
        formd.append("pageNum",mpage)
        formd.append("status",code)
        formd.append("matchName",name)
        formd.append("gameId",gameId)
        formd.append("page",_this.gamePage)
        formd.append("seriesId",29)

        this.$axios.post("http://admin.matchon.net/phoneClient/getMatchList",formd).then((data) => {
          if(data.data.code==200){
            _this.gameAllPage=Math.ceil(data.data.data.list.total/8)
            let arr=[]
            for(var k in _this.gameList){
              arr.push(_this.gameList[k])
            }
            for(var key in data.data.data.list.data){
              arr.push(data.data.data.list.data[key])
            }
            _this.gameList=arr
          }
        });
      },
      loginData(){
        this.gamePage++
        if(this.gamePage>this.gameAllPage){
          this.gamePag=this.gameAllPage
          alert("没有更多赛事")
        }else{
          this.gamehData(8,"","","")
        }
      },
      listData(){
        let _this=this;
        let formd=new FormData()
        formd.append("seriesId",29)
        this.$axios.post("http://admin.matchon.net/client/getSeriesGamerMoneyList",formd).then((data) => {
          if(data.data.code==200){
            _this.list=data.data.data.list
          }
        });
      },
      //  新闻
      newsData(){
        let _this=this;
        let formd=new FormData()
        formd.append("rowNum",3)
        formd.append("seriesId",29)
        this.$axios.post("http://admin.matchon.net/client/getNewsList",formd).then((data) => {
          if(data.data.code==200){
            _this.newsList=data.data.data;
          }
        });
      },
      gameFun(jumpAddress){
        window.open(jumpAddress)
      },
      newFun(id){
        this.$router.push({path: '/newDetails', query: {nid: id}})
      },
      urlFun(url){
//        this.$router.push({path:`/new/${id}`})
        this.$router.push({path:url})
      },

    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Home.vue